const getSignalGroupAndName = (signalKey) => {
  // accounts for any signals with more than one level of nesting
  // eg: `Charge.ChargeLimitConfiguration.Global`
  // signalGroup = `Charge`
  // signal = `ChargeLimitConfiguration.Global`
  const [signalGroup, ...rest] = signalKey.split('.');
  const signal = rest.join('.');
  return { signalGroup, signal };
};

const getSelectedSignalsByGroup = (allSignals, selectedSignals) => {
  const selectedSignalsByGroup = {};
  Array.from(selectedSignals).forEach((signalKey) => {
    if (signalKey.includes('.*')) {
      const signalGroup = signalKey.replace('.*', '');
      // if signal group is not in allSignals, skip it
      // this can happen if the signal group has been removed from the signal data
      if (allSignals[signalGroup] === undefined) {
        return;
      }
      selectedSignalsByGroup[signalGroup] = allSignals[signalGroup];
    } else {
      const { signalGroup, signal } = getSignalGroupAndName(signalKey);
      if (allSignals[signalGroup] === undefined) {
        return;
      }
      if (!selectedSignalsByGroup[signalGroup]) {
        selectedSignalsByGroup[signalGroup] = [];
      }
      const signalData = allSignals[signalGroup].find(({ name }) => name === signal);
      if (!signalData) {
        return;
      }
      selectedSignalsByGroup[signalGroup].push(signalData);
    }
  });
  return selectedSignalsByGroup;
};

// Counts total of selected signals, including signals
// within a selected group. Skips any previously
// selected signals that are no longer found in the signal data
const getSelectedSignalCount = (signals, selectedSignals) => {
  const count = [...selectedSignals].reduce((acc, signalKey) => {
    const isSignalGroup = signalKey.includes('.*');
    if (isSignalGroup) {
      const [groupName] = signalKey.split('.*');
      if (!signals[groupName]) {
        return acc;
      }
      return acc + signals[groupName].length;
    }
    const { signalGroup, signal } = getSignalGroupAndName(signalKey);
    const signalData = signals[signalGroup] ?
      signals[signalGroup].find(({ name }) => name === signal) : null;
    if (!signalData) {
      return acc;
    }
    return acc + 1;
  }, 0);
  return count;
};

const getSelectedSignalCountByGroup = (signalGroupName, signals, selectedSignals) => {
  const selectedSignalsByGroup = getSelectedSignalsByGroup(signals, selectedSignals);
  const selectedSignalCount = selectedSignalsByGroup[signalGroupName]
    ? selectedSignalsByGroup[signalGroupName].length
    : 0;
  return selectedSignalCount;
};

const signalNamesChanged = (signalSetA, signalSetB) => {
  if (signalSetA.size !== signalSetB.size) {
    return true;
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const signal of signalSetA) {
    if (!signalSetB.has(signal)) {
      return true;
    }
  }
  return false;
};

const formatWebhookForm = (formValues) => {
  return {
    ...formValues,
    signalNames: Array.from(formValues.signalNames),
    callbackUri: formValues.callbackUri.trim(),
    errorCallbackUri: (typeof formValues.errorCallbackUri === 'string' && formValues.errorCallbackUri.trim() !== '') ?
      formValues.errorCallbackUri.trim()
      : null,
    // default rule, will update in phase 2 when more rules are added
    rules: ['asap'],
  };
};


export {
  getSignalGroupAndName,
  getSelectedSignalsByGroup,
  getSelectedSignalCount,
  getSelectedSignalCountByGroup,
  signalNamesChanged,
  formatWebhookForm,
};
